import React from 'react';
import ReactDOM from 'react-dom';
import './tailwind.css'; // Tailwind CSS - MUST be first
import './index.css';
import App from './app';
import { ThemeProvider } from './context/theme-context';
import { AuthProvider } from './context/auth-context';
import { CartProvider } from './context/cart-context';

// Suppress benign ResizeObserver errors
const resizeObserverErrorHandler = (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) {
            resizeObserverErr.setAttribute('style', 'display: none');
        }
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.setAttribute('style', 'display: none');
        }
    }
};
window.addEventListener('error', resizeObserverErrorHandler);

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider>
            <AuthProvider>
                <CartProvider>
                    <App />
                </CartProvider>
            </AuthProvider>
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);
